import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const GiftCardPaywall = lazyWithPreload(
  () => import('./GiftCardPaywall'),
)
